<template>
    <div>
        <section>
            <h3>PENGUASAAN KATA DALAM QURAN</h3>
            <div class="border p-2">
                <p>Dalam Bentuk Kata</p>
                <div class="progress rounded-0 bg-theme border border-green-light " style="height:20px">
                    <div class="progress-bar gradient-green" role="progressbar"
                        :style="`width: ${this.percentageKata}%`" :aria-valuenow="this.progresKata"
                        :aria-valuemin="this.totalKata" aria-valuemax="100">{{ this.percentageKata }}%</div>
                </div>
                <p>{{ this.progresKata }} dari {{ this.totalKata }} kata</p>
            </div>
        </section>

        <section class="mt-2">
            <div class="border p-2">
                <p>Dalam Sebuah Ayat</p>
                <div class="progress rounded-0 bg-theme border border-red-light " style="height:20px">
                    <div class="progress-bar gradient-red" role="progressbar" :style="`width: ${this.percentageAyat}%`"
                        :aria-valuenow="this.progresAyat" aria-valuemin="0" :aria-valuemax="this.totalAyat">{{
                            this.percentageAyat
                        }}%</div>
                </div>
                <p>{{ this.progresAyat }} dari {{ this.totalAyat }} ayat</p>
            </div>
        </section>

        <div class="mt-2">
            <router-link :to="{ name: 'learnQuranWord' }" class="btn btn-warning"><i class="bi bi-play-fill"></i>
                Melanjutkan</router-link>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import VueCookie from 'vue-cookie'
export default {
    name: 'ProgressLearn',
    data() {
        return {
            progresKata: 0,
            totalKata: 0,
            progresAyat: 0,
            totalAyat: 0,
            percentageKata: 0,
            percentageAyat: 0,
        };
    },
    async created() {
        let auth = VueCookie.get('token')
       if (auth) {
           await this.$store.dispatch('auth/getProgressLearn');
           this.progresKata = this.progress.progresKata;
           this.totalKata = this.progress.totalKata;
           this.progresAyat = this.progress.progresAyat;
           this.totalAyat = this.progress.totalAyat;
           this.percentageKata = (this.progresKata / this.totalKata) * 100;
           this.percentageAyat = (this.progresAyat / this.totalAyat) * 100;
        }
    },
    computed: {
        ...mapState('auth', {
            progress: state => state.progress,
        }),
    },
}
</script>

<style scoped>
    .progress-card {
        background-color: #6558f5;
    }
    .progress-read {
        background-color: #d3455b;
    }
    .progress-read p {
        color: white;
        margin-bottom: 0;
        margin-top: 5px;
    }
    .progress-card h3 {
        color: #f7c325;
    }
    .border p {
        color: white;
        margin-bottom: 0;
    }
</style>